// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function immutableClass(ObjectClass) {
  Object.freeze(ObjectClass);
  var propertyNames = Object.getOwnPropertyNames(ObjectClass.prototype);
  propertyNames.filter(function (name) {
    return name !== 'constructor';
  }).forEach(function (name) {
    return Object.defineProperty(ObjectClass.prototype, name, {
      writable: false
    });
  });
  Object.seal(ObjectClass.prototype);
  return ObjectClass;
}
export function immutableBaseClass(ObjectClass) {
  Object.setPrototypeOf(ObjectClass.prototype, null);
  immutableClass(ObjectClass);
  return ObjectClass;
}
export function frozenClass(ObjectClass) {
  Object.setPrototypeOf(ObjectClass.prototype, null);
  Object.freeze(ObjectClass.prototype);
  Object.freeze(ObjectClass);
  return ObjectClass;
}
export function readOnlyBinaryProperty(obj, name, value) {
  // should this also add a zero property?
  // and should it create a local value?  maybe not.
  var safeValue = new Uint8Array(value);
  Object.defineProperty(obj, name, {
    get: function get() {
      return new Uint8Array(safeValue);
    },
    enumerable: true
  });
}
export function readOnlyProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    value: value,
    enumerable: true
  });
}